import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { AddExistingPromptComponent } from './containers/add-existing-prompt.component';
import { AddExistingPromptViewComponent } from './views/add-existing-prompt-view.component';

@NgModule({
   declarations: [AddExistingPromptComponent, AddExistingPromptViewComponent],
   exports: [AddExistingPromptComponent],
   imports: [
      ReactiveFormsModule,
      FormsModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      MatDialogModule,
      MatFormFieldModule,
      CommonModule,
      MatButtonModule,
      EntitySelectModule,
   ],
})
export class AddExistingPromptModule {}
